import type { AssessmentsData, Client, PlatformApi, PlatformAssessment } from "@pandas/http-client";
import type { ComponentVersion } from "../../assessmentEngineConfig";

let _platformApi: PlatformApi;
let _actors: Client[];

export function setPlatformApi(api: PlatformApi) {
	_platformApi = api;
}

export function setActors(actors: Client[]) {
	_actors = actors;
}

export async function getAssessmentTypeComponents(
	deviceType: string,
	version: ComponentVersion,
): Promise<AssessmentsData> {
	return _platformApi.getSupportedAssessments(version, deviceType, _actors);
}

export async function postAssessments(assessments: PlatformAssessment[], sessionId: string) {
	return _platformApi.submitAssessments(sessionId, assessments);
}
